export enum MODAL_EVENT_BUS_ACTIONS {
  TOGGLE_MODAL = "MODAL_EVENT_BUS_ACTIONS.TOGGLE_MODAL",
  TOGGLE_VIEW_MODE = "MODAL_EVENT_BUS_ACTIONS.TOGGLE_VIEW_MODE",
}
